"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOpenSingleGalleryModal = exports.getWatermark = exports.getThumbsPhotos = exports.getPhotosCategoriesByHotel = exports.getPhotosByCategories = exports.getPhotos = void 0;
var _reselect = require("reselect");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/static/selectors");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _selectors3 = require("../../../../../modalDispatcher/store/selectors");
var _constants = require("../constants");
var _constants2 = require("./constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var EMPTY_ARRAY = [];
var getPhotosByCategory = function getPhotosByCategory() {
  return (0, _reselect.createSelector)((0, _selectors.getHotel)(), function (_ref) {
    var photosByCategory = _ref.photosByCategory;
    return R.any(function (_ref2) {
      var category = _ref2.category;
      return category;
    }, photosByCategory) ? R.map(R.over(R.lensProp('category'), function (category) {
      return category || _constants.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME;
    }), photosByCategory) : EMPTY_ARRAY;
  });
};
var getWatermark = exports.getWatermark = function getWatermark() {
  return (0, _reselect.createSelector)((0, _selectors.getHotel)(), R.prop('watermark'));
};
var getPhotosCategoriesByHotel = exports.getPhotosCategoriesByHotel = function getPhotosCategoriesByHotel() {
  return (0, _reselect.createSelector)(getPhotosByCategory(), _selectors2.getPhotosCategories, function (photosByCategory, categories) {
    return R.call(R.pipe(R.filter(function (category) {
      return R.any(R.pathEq(category.id, ['category', 'id']), photosByCategory);
    }), R.when(function (allowCategories) {
      return !R.isEmpty(allowCategories) && R.any(function (_ref3) {
        var category = _ref3.category;
        return category.id === _constants.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME.id;
      }, photosByCategory);
    }, R.append(_constants.WITHOUT_CATEGORY_PHOTO_CATEGORY_NAME))), categories);
  });
};
var getOriginalPhotosByCategories = function getOriginalPhotosByCategories() {
  return (0, _reselect.createSelector)(getPhotosByCategory(), getPhotosCategoriesByHotel(), function (photosByCategory, categories) {
    var categoriesMap = R.fromPairs(R.map(function (category) {
      return [category.id, category];
    }, categories));
    return R.call(R.pipe(R.groupBy(R.path(['category', 'id'])), R.toPairs, R.map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        categoryID = _ref5[0],
        photos = _ref5[1];
      return {
        category: categoriesMap[categoryID],
        photos: R.map(R.prop('photo'), photos)
      };
    }), R.sort(function (groupA, groupB) {
      return R.subtract(R.findIndex(function (_ref6) {
        var id = _ref6.id;
        return id === groupA.category.id;
      }, categories), R.findIndex(function (_ref7) {
        var id = _ref7.id;
        return id === groupB.category.id;
      }, categories));
    })), photosByCategory);
  });
};
var getPhotosByCategories = exports.getPhotosByCategories = function getPhotosByCategories() {
  return (0, _reselect.createSelector)(getOriginalPhotosByCategories(), getWatermark(), function (photosByCategories, watermark) {
    return R.map(R.over(R.lensProp('photos'), R.map(function (photo) {
      return (0, _dictionary.getImageUrl)(photo, 'veryLarge', watermark);
    })), photosByCategories);
  });
};
var getOriginalPhotos = function getOriginalPhotos() {
  return (0, _reselect.createSelector)((0, _selectors.getHotel)(), R.prop('photos'));
};
var getPhotos = exports.getPhotos = function getPhotos() {
  return (0, _reselect.createSelector)(getOriginalPhotos(), getWatermark(), function (photos, watermark) {
    return R.map(function (photo) {
      return (0, _dictionary.getImageUrl)(photo, 'veryLarge', watermark);
    }, photos);
  });
};
var getThumbsPhotos = exports.getThumbsPhotos = function getThumbsPhotos() {
  return (0, _reselect.createSelector)(getOriginalPhotos(), getOriginalPhotosByCategories(), function (photos, photosByCategories) {
    return R.isEmpty(photosByCategories) ? photos : R.reduce(function (acc, group) {
      return R.concat(acc, group.photos);
    }, [], photosByCategories);
  });
};
var isOpenSingleGalleryModal = exports.isOpenSingleGalleryModal = R.partialRight((0, _selectors3.isOpen)(), [{
  key: _constants2.SINGLE_GALLERY_MODAL_KEY
}]);